<template>
<div class="home">
    <v-row>
        <v-col lg="10" offset-md="1">
            <s-crud title="Numeración de Documentos" restore formPermanent sortable pdf excel edit add remove :config="this.config" @save="saveNud($event)">
                <template scope="props">
                    <v-container v-if="props.item != null" class="pb-0">
                        <v-row class="justify-center">
                        <v-col cols="12" md="6" class="s-col-form">
                                <s-select-definition :disabled="props.item.NudID > 0" :def="1142" v-model="props.item.TypeBusiness" label="Empresa" />
                            </v-col>
                            <v-col cols="12" md="6" class="s-col-form">
                                <s-select-definition :disabled="props.item.NudID > 0" :def="1179" v-model="props.item.TypeProcess" label="Tipo
                    Documento" />
                            </v-col>
                            <v-col cols="4" md="3" class="s-col-form">
                                <s-text v-model="props.item.NudSerie" label="Serie" />
                            </v-col>
                            <v-col cols="4" md="3" class="s-col-form">
                                <s-text v-model="props.item.NudCorrelative" number label="Correlativo" />
                            </v-col>
                            <v-col cols="4" md="6" class="s-col-form">
                                <s-text v-model="props.item.NudAbbreviation" label="Abreviatura" />
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </s-crud>
        </v-col>
    </v-row>
</div>
</template>

<script>
import _sNumeration from "@/services/General/NumerationDocumentLegalService";
export default {
    data: () => ({
        config: {
            model: {
                NudID: "ID",
                NudSerie: "string",
                NudCorrelative: "string",
                SecStatus: "status",
            },

            service: _sNumeration,

            headers: [{
                    text: "ID",
                    align: "start",
                    sortable: false,
                    value: "NudID",
                },
                {
                    text: "Empresa",
                    value: "TypeBusinessName",
                    sortable: false,
                },
                {
                    text: "Documento",
                    value: "TypeProcessName",
                },
                {
                    text: "Serie",
                    value: "NudSerie",
                    sortable: false,
                },
                {
                    text: "Correlativo",
                    value: "NudCorrelative",
                    sortable: false,
                },
                {
                    text: "Abbreviatura",
                    value: "NudAbbreviation",
                    sortable: false,
                },
                {
                    text: "Estado",
                    value: "SecStatus",
                },
            ],
        },
    }),

    methods: {
        validatedNud(item) {
            let isValid = false;
            let message = "";

            isValid = item.TypeProcess > 0;

            if (!isValid) message = "Seleccione un tipo de documento";
            else {
                isValid = item.NudCorrelative >= 0;
                if (!isValid) message = "Registre correlativo válido";
            }

            if (!isValid) this.$fun.alert(message, "warning");

            return isValid;
        },
        saveNud(item) {
            item.SecStatus = 1
            item.UsrCreateID = this.$fun.getUserID()
            console.log("SAVE", item)
            if (this.validatedNud(item)) item.save();
        },
    },
};
</script>
